import { Card } from '@/utils/models/cards';
import { colors } from '@zopauk/react-components';
import { faExclamationTriangle, faExclamationCircle, faClock } from '@fortawesome/free-solid-svg-icons';

export const getIcon = (template: Card['template']) => {
  let icon;

  switch (template) {
    case 'awaitingDecision':
      icon = { color: colors.warning, variant: faClock };
      break;
    case 'critical':
      icon = { variant: faExclamationTriangle, color: colors.alert };
      break;
    case 'alert':
      icon = { variant: faExclamationCircle, color: colors.warning };
      break;
  }

  return icon;
};
